<template>

</template>

<script>

import MerchantLayout from "../../Layouts/MerchantLayout.vue";

export default {
    name: "Home",
    layout: MerchantLayout,
}
</script>

<style scoped>

</style>
